import React, { useEffect, useState } from "react";
import { isMobile } from "../../utils";
import { ContainerBanner, NewContainer } from "./styles";
import NewLogoSVG from "../../components/NewLogo";

export default function OnboardStep({ plan }) {
	const [bannerUrl, setBannerUrl] = useState(null);
	const [bannerUrlFundo, setbannerUrlFundo] = useState(null);

	useEffect(() => {
		if (plan) {
			setBannerUrl(
				!isMobile.any()
					? plan.promotional_banner_url
					: plan.promotional_banner_url_mobile
			);
			setbannerUrlFundo(plan.background);
		}
	}, [plan]);

	return bannerUrl ? (
		<ContainerBanner>
			<img className="front" src={bannerUrl} alt="" />
			<img className="background" src={bannerUrlFundo} alt="" />
		</ContainerBanner>
	) : (
		<NewContainer>
			<NewLogoSVG backButton={true} withoutLogo={true} />
		</NewContainer>
	);
}
